module.exports = __webpack_public_path__ + "static/media/hero.9074c59f.jpg";